import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Login from "../login";

const UserPrivateRoute = ({ children }) => {
  const sharedLogin = useSelector((state) => state.sharedLogin);
  const { sharedUserInfo } = sharedLogin;
  const navigate = useNavigate();

  useEffect(() => {
    if (!sharedUserInfo && !sharedUserInfo?.payload?.email) {
      navigate("/login", { replace: true });
    }
  }, [sharedUserInfo]);

  if (sharedUserInfo && sharedUserInfo?.payload?.email) {
    return children;
  } else {
    return <Login />;
  }
};

export default UserPrivateRoute;
